export default __webpack_public_path__ + "static/media/clicks.19d929ef.svg";